/*
 *
 * Users constants
 *
 */
export var GET_USERS_REQUEST = 'app/UsersInvite/GET_USERS_REQUEST';
export var GET_USERS_FAILURE = 'app/UsersInvite/GET_USERS_FAILURE';
export var GET_USERS_SUCCESS = 'app/UsersInvite/GET_USERS_SUCCESS';
export var QUERY_USERS = 'app/UsersInvite/QUERY_USERS';
export var SELECT_USER = 'app/UsersInvite/SELECT_USER';
export var SELECT_ALL_USERS = 'app/UsersInvite/SELECT_ALL_USERS';
export var INVITE_USER_REQUEST = 'app/UsersInvite/INVITE_USER_REQUEST';
export var INVITE_USER_FAILURE = 'app/UsersInvite/INVITE_USER_FAILURE';
export var INVITE_USER_SUCCESS = 'app/UsersInvite/INVITE_USER_SUCCESS';
